import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.tsx';
import { Proveedores } from './contexto.tsx';
import { iniciarMonitorConexion, registrarServiceWorker } from './pwa.ts';
import './estilos.css';

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('Falta #raiz en el HTML.');

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <Proveedores>
        <App />
      </Proveedores>
    </BrowserRouter>
  </StrictMode>,
);

//  FASE 4.5: fuera del árbol de React a propósito — el service worker no
//  depende de qué componente esté montado, y registrarlo una sola vez
//  aquí evita que un remount (StrictMode en desarrollo) lo dispare dos
//  veces.
registrarServiceWorker();
//  F14.1 — conexión REAL con el servidor (no sólo navigator.onLine): indicador global y reintentos de la cola.
iniciarMonitorConexion();
